/* eslint-disable */
export default {
  attachFiles: 'Attach file',
};

// @key: @#@"attachFiles"@#@ @source: @#@"Attach file"@#@
